import { Component, Input } from '@angular/core';
import { APPCONFIG } from '../../config'

@Component({
    selector: 'my-app-sidenav',
    styles: [require('./sidenav.component.scss')],
    template: require('./sidenav.component.html')
})

export class AppSidenavComponent {
    AppConfig;

    ngOnInit() {
        this.AppConfig = APPCONFIG;
    }

    toggleCollapsedNav() {
        this.AppConfig.navCollapsed = !this.AppConfig.navCollapsed;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/layout/sidenav/sidenav.component.ts